export default __webpack_public_path__ + "static/media/food-on-the-table.b9ca24c1.jpg";